// @generated by protoc-gen-es v2.2.3 with parameter "target=ts"
// @generated from file dashboard/v1/audiobooks.proto (package dashboard.audiobooks.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv1";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv1";
import type { Empty, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file dashboard/v1/audiobooks.proto.
 */
export const file_dashboard_v1_audiobooks: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_google_protobuf_empty]);

/**
 * @generated from message dashboard.audiobooks.v1.GetAudiobooksRequest
 */
export type GetAudiobooksRequest = Message<"dashboard.audiobooks.v1.GetAudiobooksRequest"> & {
};

/**
 * Describes the message dashboard.audiobooks.v1.GetAudiobooksRequest.
 * Use `create(GetAudiobooksRequestSchema)` to create a new message.
 */
export const GetAudiobooksRequestSchema: GenMessage<GetAudiobooksRequest> = /*@__PURE__*/
  messageDesc(file_dashboard_v1_audiobooks, 0);

/**
 * @generated from message dashboard.audiobooks.v1.GetAudiobookRequest
 */
export type GetAudiobookRequest = Message<"dashboard.audiobooks.v1.GetAudiobookRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message dashboard.audiobooks.v1.GetAudiobookRequest.
 * Use `create(GetAudiobookRequestSchema)` to create a new message.
 */
export const GetAudiobookRequestSchema: GenMessage<GetAudiobookRequest> = /*@__PURE__*/
  messageDesc(file_dashboard_v1_audiobooks, 1);

/**
 * @generated from message dashboard.audiobooks.v1.Chapter
 */
export type Chapter = Message<"dashboard.audiobooks.v1.Chapter"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: optional string description = 3;
   */
  description?: string;

  /**
   * @generated from field: optional string multimedia_id = 4;
   */
  multimediaId?: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp;
};

/**
 * Describes the message dashboard.audiobooks.v1.Chapter.
 * Use `create(ChapterSchema)` to create a new message.
 */
export const ChapterSchema: GenMessage<Chapter> = /*@__PURE__*/
  messageDesc(file_dashboard_v1_audiobooks, 2);

/**
 * @generated from message dashboard.audiobooks.v1.Audiobook
 */
export type Audiobook = Message<"dashboard.audiobooks.v1.Audiobook"> & {
  /**
   * @generated from field: optional string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string project_id = 2;
   */
  projectId: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * @generated from field: string cover_image = 5;
   */
  coverImage: string;

  /**
   * @generated from field: string thumbnail_image = 6;
   */
  thumbnailImage: string;

  /**
   * @generated from field: repeated dashboard.audiobooks.v1.Chapter chapters = 7;
   */
  chapters: Chapter[];

  /**
   * @generated from field: bool is_downloadable = 8;
   */
  isDownloadable: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 9;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: optional bool is_browser_downloadable = 10;
   */
  isBrowserDownloadable?: boolean;

  /**
   * @generated from field: optional string accent_color = 11;
   */
  accentColor?: string;
};

/**
 * Describes the message dashboard.audiobooks.v1.Audiobook.
 * Use `create(AudiobookSchema)` to create a new message.
 */
export const AudiobookSchema: GenMessage<Audiobook> = /*@__PURE__*/
  messageDesc(file_dashboard_v1_audiobooks, 3);

/**
 * @generated from message dashboard.audiobooks.v1.GetAudiobooksResponse
 */
export type GetAudiobooksResponse = Message<"dashboard.audiobooks.v1.GetAudiobooksResponse"> & {
  /**
   * @generated from field: repeated dashboard.audiobooks.v1.Audiobook audiobooks = 1;
   */
  audiobooks: Audiobook[];
};

/**
 * Describes the message dashboard.audiobooks.v1.GetAudiobooksResponse.
 * Use `create(GetAudiobooksResponseSchema)` to create a new message.
 */
export const GetAudiobooksResponseSchema: GenMessage<GetAudiobooksResponse> = /*@__PURE__*/
  messageDesc(file_dashboard_v1_audiobooks, 4);

/**
 * @generated from message dashboard.audiobooks.v1.GetAudiobookResponse
 */
export type GetAudiobookResponse = Message<"dashboard.audiobooks.v1.GetAudiobookResponse"> & {
  /**
   * @generated from field: optional dashboard.audiobooks.v1.Audiobook audiobook = 1;
   */
  audiobook?: Audiobook;
};

/**
 * Describes the message dashboard.audiobooks.v1.GetAudiobookResponse.
 * Use `create(GetAudiobookResponseSchema)` to create a new message.
 */
export const GetAudiobookResponseSchema: GenMessage<GetAudiobookResponse> = /*@__PURE__*/
  messageDesc(file_dashboard_v1_audiobooks, 5);

/**
 * @generated from message dashboard.audiobooks.v1.CreateOrUpdateAudiobookRequest
 */
export type CreateOrUpdateAudiobookRequest = Message<"dashboard.audiobooks.v1.CreateOrUpdateAudiobookRequest"> & {
  /**
   * @generated from field: dashboard.audiobooks.v1.Audiobook audiobook = 1;
   */
  audiobook?: Audiobook;
};

/**
 * Describes the message dashboard.audiobooks.v1.CreateOrUpdateAudiobookRequest.
 * Use `create(CreateOrUpdateAudiobookRequestSchema)` to create a new message.
 */
export const CreateOrUpdateAudiobookRequestSchema: GenMessage<CreateOrUpdateAudiobookRequest> = /*@__PURE__*/
  messageDesc(file_dashboard_v1_audiobooks, 6);

/**
 * @generated from message dashboard.audiobooks.v1.CreateOrUpdateAudiobookResponse
 */
export type CreateOrUpdateAudiobookResponse = Message<"dashboard.audiobooks.v1.CreateOrUpdateAudiobookResponse"> & {
  /**
   * @generated from oneof dashboard.audiobooks.v1.CreateOrUpdateAudiobookResponse.result
   */
  result: {
    /**
     * @generated from field: dashboard.audiobooks.v1.CreateOrUpdateAudiobookResponse.Result success = 1;
     */
    value: CreateOrUpdateAudiobookResponse_Result;
    case: "success";
  } | {
    /**
     * @generated from field: dashboard.audiobooks.v1.FailureMessage failure = 2;
     */
    value: FailureMessage;
    case: "failure";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message dashboard.audiobooks.v1.CreateOrUpdateAudiobookResponse.
 * Use `create(CreateOrUpdateAudiobookResponseSchema)` to create a new message.
 */
export const CreateOrUpdateAudiobookResponseSchema: GenMessage<CreateOrUpdateAudiobookResponse> = /*@__PURE__*/
  messageDesc(file_dashboard_v1_audiobooks, 7);

/**
 * @generated from message dashboard.audiobooks.v1.CreateOrUpdateAudiobookResponse.Result
 */
export type CreateOrUpdateAudiobookResponse_Result = Message<"dashboard.audiobooks.v1.CreateOrUpdateAudiobookResponse.Result"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message dashboard.audiobooks.v1.CreateOrUpdateAudiobookResponse.Result.
 * Use `create(CreateOrUpdateAudiobookResponse_ResultSchema)` to create a new message.
 */
export const CreateOrUpdateAudiobookResponse_ResultSchema: GenMessage<CreateOrUpdateAudiobookResponse_Result> = /*@__PURE__*/
  messageDesc(file_dashboard_v1_audiobooks, 7, 0);

/**
 * @generated from message dashboard.audiobooks.v1.DeleteAudiobookRequest
 */
export type DeleteAudiobookRequest = Message<"dashboard.audiobooks.v1.DeleteAudiobookRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message dashboard.audiobooks.v1.DeleteAudiobookRequest.
 * Use `create(DeleteAudiobookRequestSchema)` to create a new message.
 */
export const DeleteAudiobookRequestSchema: GenMessage<DeleteAudiobookRequest> = /*@__PURE__*/
  messageDesc(file_dashboard_v1_audiobooks, 8);

/**
 * @generated from message dashboard.audiobooks.v1.GetAudiobookAccessEmailsRequest
 */
export type GetAudiobookAccessEmailsRequest = Message<"dashboard.audiobooks.v1.GetAudiobookAccessEmailsRequest"> & {
  /**
   * @generated from field: string audiobook_id = 1;
   */
  audiobookId: string;

  /**
   * @generated from field: optional string email = 2;
   */
  email?: string;
};

/**
 * Describes the message dashboard.audiobooks.v1.GetAudiobookAccessEmailsRequest.
 * Use `create(GetAudiobookAccessEmailsRequestSchema)` to create a new message.
 */
export const GetAudiobookAccessEmailsRequestSchema: GenMessage<GetAudiobookAccessEmailsRequest> = /*@__PURE__*/
  messageDesc(file_dashboard_v1_audiobooks, 9);

/**
 * @generated from message dashboard.audiobooks.v1.GetAudiobookAccessEmailsResponse
 */
export type GetAudiobookAccessEmailsResponse = Message<"dashboard.audiobooks.v1.GetAudiobookAccessEmailsResponse"> & {
  /**
   * @generated from oneof dashboard.audiobooks.v1.GetAudiobookAccessEmailsResponse.result
   */
  result: {
    /**
     * @generated from field: dashboard.audiobooks.v1.GetAudiobookAccessEmailsResponse.Result success = 1;
     */
    value: GetAudiobookAccessEmailsResponse_Result;
    case: "success";
  } | {
    /**
     * @generated from field: dashboard.audiobooks.v1.FailureMessage failure = 2;
     */
    value: FailureMessage;
    case: "failure";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message dashboard.audiobooks.v1.GetAudiobookAccessEmailsResponse.
 * Use `create(GetAudiobookAccessEmailsResponseSchema)` to create a new message.
 */
export const GetAudiobookAccessEmailsResponseSchema: GenMessage<GetAudiobookAccessEmailsResponse> = /*@__PURE__*/
  messageDesc(file_dashboard_v1_audiobooks, 10);

/**
 * @generated from message dashboard.audiobooks.v1.GetAudiobookAccessEmailsResponse.AccessEmail
 */
export type GetAudiobookAccessEmailsResponse_AccessEmail = Message<"dashboard.audiobooks.v1.GetAudiobookAccessEmailsResponse.AccessEmail"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string email = 2;
   */
  email: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 3;
   */
  createdAt?: Timestamp;
};

/**
 * Describes the message dashboard.audiobooks.v1.GetAudiobookAccessEmailsResponse.AccessEmail.
 * Use `create(GetAudiobookAccessEmailsResponse_AccessEmailSchema)` to create a new message.
 */
export const GetAudiobookAccessEmailsResponse_AccessEmailSchema: GenMessage<GetAudiobookAccessEmailsResponse_AccessEmail> = /*@__PURE__*/
  messageDesc(file_dashboard_v1_audiobooks, 10, 0);

/**
 * @generated from message dashboard.audiobooks.v1.GetAudiobookAccessEmailsResponse.Result
 */
export type GetAudiobookAccessEmailsResponse_Result = Message<"dashboard.audiobooks.v1.GetAudiobookAccessEmailsResponse.Result"> & {
  /**
   * @generated from field: repeated dashboard.audiobooks.v1.GetAudiobookAccessEmailsResponse.AccessEmail emails = 1;
   */
  emails: GetAudiobookAccessEmailsResponse_AccessEmail[];
};

/**
 * Describes the message dashboard.audiobooks.v1.GetAudiobookAccessEmailsResponse.Result.
 * Use `create(GetAudiobookAccessEmailsResponse_ResultSchema)` to create a new message.
 */
export const GetAudiobookAccessEmailsResponse_ResultSchema: GenMessage<GetAudiobookAccessEmailsResponse_Result> = /*@__PURE__*/
  messageDesc(file_dashboard_v1_audiobooks, 10, 1);

/**
 * @generated from message dashboard.audiobooks.v1.CreateAudiobookAccessRequest
 */
export type CreateAudiobookAccessRequest = Message<"dashboard.audiobooks.v1.CreateAudiobookAccessRequest"> & {
  /**
   * @generated from field: string audiobook_id = 1;
   */
  audiobookId: string;

  /**
   * @generated from field: string email = 2;
   */
  email: string;
};

/**
 * Describes the message dashboard.audiobooks.v1.CreateAudiobookAccessRequest.
 * Use `create(CreateAudiobookAccessRequestSchema)` to create a new message.
 */
export const CreateAudiobookAccessRequestSchema: GenMessage<CreateAudiobookAccessRequest> = /*@__PURE__*/
  messageDesc(file_dashboard_v1_audiobooks, 11);

/**
 * @generated from message dashboard.audiobooks.v1.DeleteAudiobookAccessRequest
 */
export type DeleteAudiobookAccessRequest = Message<"dashboard.audiobooks.v1.DeleteAudiobookAccessRequest"> & {
  /**
   * @generated from field: string system_access_id = 1;
   */
  systemAccessId: string;
};

/**
 * Describes the message dashboard.audiobooks.v1.DeleteAudiobookAccessRequest.
 * Use `create(DeleteAudiobookAccessRequestSchema)` to create a new message.
 */
export const DeleteAudiobookAccessRequestSchema: GenMessage<DeleteAudiobookAccessRequest> = /*@__PURE__*/
  messageDesc(file_dashboard_v1_audiobooks, 12);

/**
 * @generated from message dashboard.audiobooks.v1.BoolResponse
 */
export type BoolResponse = Message<"dashboard.audiobooks.v1.BoolResponse"> & {
  /**
   * @generated from oneof dashboard.audiobooks.v1.BoolResponse.result
   */
  result: {
    /**
     * @generated from field: google.protobuf.Empty success = 1;
     */
    value: Empty;
    case: "success";
  } | {
    /**
     * @generated from field: dashboard.audiobooks.v1.FailureMessage failure = 2;
     */
    value: FailureMessage;
    case: "failure";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message dashboard.audiobooks.v1.BoolResponse.
 * Use `create(BoolResponseSchema)` to create a new message.
 */
export const BoolResponseSchema: GenMessage<BoolResponse> = /*@__PURE__*/
  messageDesc(file_dashboard_v1_audiobooks, 13);

/**
 * @generated from enum dashboard.audiobooks.v1.FailureMessage
 */
export enum FailureMessage {
  /**
   * @generated from enum value: FAILURE_MESSAGE_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: FAILURE_MESSAGE_PROJECT_NOT_FOUND = 1;
   */
  PROJECT_NOT_FOUND = 1,

  /**
   * @generated from enum value: FAILURE_MESSAGE_CHAPTER_NOT_FOUND = 2;
   */
  CHAPTER_NOT_FOUND = 2,

  /**
   * @generated from enum value: FAILURE_MESSAGE_INCORRECT_CHAPTER_FORMAT = 3;
   */
  INCORRECT_CHAPTER_FORMAT = 3,
}

/**
 * Describes the enum dashboard.audiobooks.v1.FailureMessage.
 */
export const FailureMessageSchema: GenEnum<FailureMessage> = /*@__PURE__*/
  enumDesc(file_dashboard_v1_audiobooks, 0);

/**
 * @generated from service dashboard.audiobooks.v1.AudiobooksService
 */
export const AudiobooksService: GenService<{
  /**
   * @generated from rpc dashboard.audiobooks.v1.AudiobooksService.GetAudiobooks
   */
  getAudiobooks: {
    methodKind: "unary";
    input: typeof GetAudiobooksRequestSchema;
    output: typeof GetAudiobooksResponseSchema;
  },
  /**
   * @generated from rpc dashboard.audiobooks.v1.AudiobooksService.GetAudiobook
   */
  getAudiobook: {
    methodKind: "unary";
    input: typeof GetAudiobookRequestSchema;
    output: typeof GetAudiobookResponseSchema;
  },
  /**
   * @generated from rpc dashboard.audiobooks.v1.AudiobooksService.CreateOrUpdateAudiobook
   */
  createOrUpdateAudiobook: {
    methodKind: "unary";
    input: typeof CreateOrUpdateAudiobookRequestSchema;
    output: typeof CreateOrUpdateAudiobookResponseSchema;
  },
  /**
   * @generated from rpc dashboard.audiobooks.v1.AudiobooksService.DeleteAudiobook
   */
  deleteAudiobook: {
    methodKind: "unary";
    input: typeof DeleteAudiobookRequestSchema;
    output: typeof BoolResponseSchema;
  },
  /**
   * @generated from rpc dashboard.audiobooks.v1.AudiobooksService.GetAudiobookAccessEmails
   */
  getAudiobookAccessEmails: {
    methodKind: "unary";
    input: typeof GetAudiobookAccessEmailsRequestSchema;
    output: typeof GetAudiobookAccessEmailsResponseSchema;
  },
  /**
   * @generated from rpc dashboard.audiobooks.v1.AudiobooksService.CreateAudiobookAccess
   */
  createAudiobookAccess: {
    methodKind: "unary";
    input: typeof CreateAudiobookAccessRequestSchema;
    output: typeof BoolResponseSchema;
  },
  /**
   * @generated from rpc dashboard.audiobooks.v1.AudiobooksService.DeleteAudiobookAccess
   */
  deleteAudiobookAccess: {
    methodKind: "unary";
    input: typeof DeleteAudiobookAccessRequestSchema;
    output: typeof BoolResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_dashboard_v1_audiobooks, 0);

